import React, {useEffect, useState} from 'react';
import Box from "@mui/material/Box";
import {Fade, Theme} from "@mui/material";
import useScrollTrigger from "@mui/material/useScrollTrigger";
import CloseIcon from "@mui/icons-material/Close";
import IconButton from "@mui/material/IconButton";

import BaseDataContent, {BaseDataContentProps} from "../DetailsContent/BaseDataContent";

interface FadeInDetailsContentProps extends BaseDataContentProps {
    target: Node | Window | undefined
    style?: { [key: string]: string | number }
    threshold?: number
}

const defaultStyle = {
    backgroundColor: (theme: Theme) => theme.palette.grey[200],
    top: 30,
    left: 30,
    borderRadius: "5px",
    width: "auto",
    position: "fixed",
    padding: "5px",
    display: "flex",
    flexDirection: "column",
    zIndex: 100
}

const FadeInDetailsContent: React.FC<FadeInDetailsContentProps> = ({
                                                                       target,
                                                                       threshold = 100,
                                                                       baseData,
                                                                       recruitEmail,
                                                                       style = {...defaultStyle},
    mandate,
                                                                   }) => {
    const [appear, setAppear] = useState<boolean>(false);

    const trigger = useScrollTrigger({
        target: target,
        disableHysteresis: true,
        threshold: threshold
    });

    useEffect(() => {
        setAppear(trigger)
    }, [target, trigger])

    return (
        <Fade in={appear}>
            <Box sx={{...defaultStyle, ...style}}>
                <IconButton
                    aria-label="close"
                    onClick={() => setAppear(false)}
                    sx={{ color: (theme: Theme) => theme.palette.grey[500], alignSelf: "end"
                    }}
                >
                    <CloseIcon/>
                </IconButton>
                <BaseDataContent baseData={baseData} recruitEmail={recruitEmail} mandate={mandate}/>
            </Box>
        </Fade>
    );
};

export default FadeInDetailsContent;